import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { request } from '@koi-design/vix-tools';
import HomePage from './views/home/HomePage';
import AiAdvisorDiagnosis from './views/aiAdvisorDiagnosis/index'; // 假设新增一个 Holdings 组件
import AiAdvisorCustomAssetAllocation from './views/aiAdvisorCustomAssetAllocation/index';
import AiAdvisorRiskAssessment from './views/aiAdvisorRiskAssessment/index';
import NotFound from './views/NotFound'; // 导入 404 组件
// 认证相关页面
import WecomCheck from './views/auth/WecomCheck';
import { Toaster } from '@/components/ui/sonner';
import AuthGuard from '@/components/AuthGuard';
import { initVConsole } from '@/utils/vconsole';
import './App.css';
import './assets/tailwind/index.css';
import { requestConfig } from './config';

request.init({ ...requestConfig });

// 路由标题映射表
export const routeTitles: Record<string, string> = {
  '/': '首页',
  '/aiAdvisorDiagnosis': '持仓深度诊断',
  '/aiAdvisorCustomAssetAllocation': '定制资产配置方案',
  '/aiAdvisorRiskAssessment': 'AI投顾洞察',
  '*': '页面未找到'
};
// 页面标题设置组件
const TitleSetter = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  // 监听路由变化设置标题
  useEffect(() => {
    const title = routeTitles[location.pathname] || routeTitles['*'];
    document.title = title;
  }, [location.pathname]);

  return children;
};

function App() {
  // 初始化 vconsole（只在开发环境）
  useEffect(() => {
    initVConsole();
  }, []);

  const [userInfo, setUserInfo] = useState<any>(null);

  return (
    <Router>
      <TitleSetter>
        {/* 应用标题设置 */}
        <div className="App">
          <AuthGuard setUserInfo={setUserInfo} userInfo={userInfo}>
            <Routes>
              {/* 认证相关路由 */}
              <Route path="/auth/wecom-check" element={<WecomCheck />} />
              {/* 主要页面路由 */}
              <Route path="/" element={<HomePage />} />
              <Route path="/aiAdvisorDiagnosis" element={<AiAdvisorDiagnosis />} />
              <Route
                path="/aiAdvisorCustomAssetAllocation"
                element={<AiAdvisorCustomAssetAllocation />}
              />
              <Route path="/aiAdvisorRiskAssessment" element={<AiAdvisorRiskAssessment />} />
              <Route path="*" element={<NotFound />} /> {/* 404 路由 */}
            </Routes>
          </AuthGuard>
          <Toaster position="top-center" duration={2000} />
        </div>
      </TitleSetter>
    </Router>
  );
}

export default App;
